import type { Opportunity } from './types';

export const OPPORTUNITIES: readonly Opportunity[] = [
  {
    type: 'intro',
    typeName: 'Introduction',
    title: 'Austin Dunbar and Jeffrey Wazen — Owner-to-Operator Transition',
    narrative: 'Both are wrestling with the same fundamental challenge: how to stop being the daily bottleneck. Austin runs a 10-person design studio; Jeffrey runs 40 telecom locations. Different scale, same core tension. They are the same age (38) and both new members — an intro now creates a bond early.',
    when: 'Surfaced today',
  },
  {
    type: 'intro',
    typeName: 'Introduction',
    title: 'Steve Brudzewski and Michael Jamieson — Innovation & Health',
    narrative: 'Steve is launching Feel Science (peptides/telehealth). Michael is integrating AI into home care. Both sit at the intersection of health and technology. Michael explicitly asked to meet AI founders — Steve\'s biotech play is adjacent enough to spark the kind of conversation Michael craves.',
    when: 'Surfaced today',
  },
  {
    type: 'event',
    typeName: 'Event Invite',
    title: 'Miami Founders Dinner — March 8',
    narrative: 'Steve Brudzewski just relocated to Miami and asked about local events in Slack. There are 14 Miami-area members confirmed for the March 8 dinner. Steve should be personally invited and seated with high-energy founders who match his connector personality.',
    when: 'Event in 13 days',
  },
  {
    type: 'win',
    typeName: 'Win to Celebrate',
    title: 'Austin Dunbar\'s Wenzel Distillery — World\'s Best Rye',
    narrative: 'Austin\'s distillery won World\'s Best Rye (Nov 2024) and World\'s Best Finished Whiskey (Feb 2024). He downplays press and accolades but this is worth celebrating in the community. A Slack post or newsletter feature shows the community notices and values its members.',
    when: 'Ongoing',
  },
  {
    type: 'intro',
    typeName: 'Introduction',
    title: 'Jeffrey Wazen and Tom Fitzgerald — Dallas Connection',
    narrative: 'Jeffrey is relocating to Dallas and his number one ask is founder friends there. Tom Fitzgerald runs a boutique hotel group from Dallas. Both operate multi-location businesses. A warm intro before Jeffrey arrives gives him someone on the ground.',
    when: 'Surfaced yesterday',
  },
] as const;
